export default "<div id=\"ecTrainerAccess\" class=\"body-fill\">\n\t<ec-trainer-access></ec-trainer-access>\n</div>\n";